<template>
    <div class="hand layout-page-box">
        <div class="layTitle">
            <div class="title">护理记录单</div>
            <div>
                <el-button type="danger" size="small" @click="close">返回留观管理</el-button>
            </div>
        </div>
        <el-form :inline="true" :model="formData" class="formBox">
            <el-form-item label="姓名">
                <el-input @input="testSX" disabled v-model.trim="formData.clientName" style="width:60%;" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="年龄">
                <el-input @input="testSX" disabled v-model.trim="formData.clientAge" style="width:60%;" placeholder="请输入年龄"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-select @input="testSX" disabled v-model="formData.clientSex" clearable placeholder="请选择性别" style="width:60%;">
                    <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="床号">
                <el-input @input="testSX" disabled v-model.trim="formData.bedNumber" style="width:60%;" placeholder="请输入床号"></el-input>
            </el-form-item>
            <el-form-item label="入院日期">
                <el-date-picker @input="testSX" disabled v-model="formData.hospitalizedTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择入院日期" style="width:135px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="诊断">
                <el-input @input="testSX" v-model.trim="formData.diagnosis" style="width:300px;" placeholder="请输入诊断"></el-input>
            </el-form-item>
        </el-form>
        <child :formData="formData"></child>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import child from './child'
import { log } from 'util';
export default {
    components: {
        child
    },
    name: 'nursingRecord',
    // props: ['formData'],
    computed: {
        ...mapState(["sexey",]),
    },
    data() {
        return {
            passData: {},
            offices: [
                {
                    name: '美容皮肤科',
                    id: '001'
                },
                {
                    name: '美容外科',
                    id: '002'
                },
                {
                    name: '注射微整科',
                    id: '003'
                },
            ],
            formData: {
                nursingRecordsList: []
            },
        }
    },
    watch: {
        $route(to, from) {
            this.init()
            // if (this.activatedFlag) {
            //     this.init()
            // } else {
            //     this.init()
            // }
        },
    },
    created() {
        this.init()
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        init() {
            // console.log(this.$route.params);
            if (this.$route.params) {
                this.passData = this.$route.params
                if (this.passData.code == 1) {
                    this.formData = this.passData
                } else if (this.passData.code == 0) {
                    this.formData = {
                        nursingRecordsList: []
                    }
                }
                this.formData.bedNumber = this.passData.bedNumber
                this.formData.clientName = this.passData.clientName
                this.formData.clientAge = this.passData.clientAge
                this.formData.clientSex = this.passData.clientSex
                this.formData.hospitalizedTime = this.passData.hospitalizedTime
                this.formData.code = this.passData.code
                // console.log('this.formData');
                // console.log(this.formData);
            }
        },
        close() {
            router.push('/observation/observation')
        },
        sure() {
            console.log(this.formData);
            this.formData.createBy = Lockr.get('skinEmpId');
            this.formData.departmentName = '美容外科'
            // 新增
            if (this.formData.code == 0) {
                this.formData.leaveObserveId = this.passData.id;
                api.requestQuiet("/leaveObserve/createNursingRecords", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '添加成功');
                        router.push({ path: '/observation/observation', query: { code: 0 }, })
                        //  router.push({ name: 'observation', params: data })
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            } else if (this.formData.code == 1) {
                this.formData.leaveObserveId = this.passData.leaveObserveId;
                api.requestQuiet("/leaveObserve/updateNursingRecords", this.formData, (res) => {
                    if (res.result == true) {
                        _g.toast("success", '修改成功');
                        router.push({ path: '/observation/observation', query: { code: 0 } })
                        // router.push('/observation/observation')
                        // this.$router.go(0);
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            }
        },
    },

}
</script>

<style scoped>
.title {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 0;
}
.people {
  margin-right: 20px;
}
.sureButton {
  display: flex;
}
.handForm {
  border: 1px solid #eee;
}
.partFooter {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
/* .layout-page-box >>> .el-form-item {
  margin-bottom: 10px !important;
} */
.formBox >>> .el-form-item__content {
  line-height: 32px !important;
}
.layTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


